define('shared/initializer/form/adapters/mixins/CardinalForgotPassword',[
  'Promise',
  'shared/util/path/ResolverFactory',
  'shared/util/cardinalAjax'
], function(
  Promise,
  PathResolverFactory,
  cardinalAjax
) {

  function Ctor() {}


  Ctor.prototype.doSubmit = function() {
    var me = this;
    var $form = me.$form;
    var $email = $form.find('[name="email"]');
    var email = $email.val();

    return Promise.resolve()
      // check with dispatcher
      .then(function() {
        return cardinalAjax('/dispatcher/web', 'POST', {
          email: email
        });
      })
      .then(function(data) {
        if (!data) {
          return Promise.resolve();
        }
        switch (data.response) {
          case 'LoginNH':
            return cardinalAjax('/reset/web/', 'POST', {
              email: email
            });
            return;
          case 'LoginOH':
            return cardinalAjax('/online/Member/submitForgotPwd/', 'POST', {
              EmailOrUserName: email
            }, true);
          case 'NotExist':
          //return successful to the user for security reasons
            return Promise.resolve();
          default:
            return Promise.resolve();
        }
      })
      .then(function(data) {
        if (!data) {
          return Promise.resolve();
        }

        switch (data.status) {
          case 'EMAIL_SENT':
            return Promise.resolve();
          case 'EMAIL_FAILED':
            throw new Error('Failed to sent email');
          default:
            return Promise.resolve();
        }
      })
  };

  return Ctor;
});

